// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"ph_a bhk_i bhk_j bhk_q bhk_vr bhk_xj bhk_er"};